import { Trans, useTranslation } from 'react-i18next'

import { useTransComponents } from '@/composables/useTransComponents'

import SummarySwirl from '../SummarySwirl'

export type SummaryPartKeyPointsProps = {
  leaving?: boolean
  title?: string
  text?: string
}

export default function SummaryPartKeyPoints({ leaving, title, text }: SummaryPartKeyPointsProps) {
  const { t } = useTranslation()
  const { components } = useTransComponents()

  return (
    <section
      className={`SummaryPartKeyPoints flex flex-col w-full items-center justify-center ${leaving ? 'transition-opacity duration-500 ease-out-quad opacity-0' : '0'}`}
    >
      <div className='container pb-40 pt-120 md:py-180'>
        <div className='col-start-1 col-span-10 md:col-start-2 md:col-span-8 lg:col-start-3 lg:col-span-8'>
          <h2
            className='text-heading-h2 text-left z-2 w-full'
            style={
              {
                '--color-accent': 'var(--color-mid-blue)',
                '--color-secondary': 'var(--color-peach)',
              } as React.CSSProperties
            }
          >
            <Trans components={components}>{title}</Trans>
          </h2>
        </div>

        <p
          className='text-body-l col-start-1 col-span-10 md:col-start-2 md:col-span-8 lg:col-start-3 lg:col-span-7 mt-24'
          style={
            {
              '--color-accent': 'var(--color-mid-blue)',
              '--color-secondary': 'var(--color-peach)',
            } as React.CSSProperties
          }
        >
          <Trans components={components}>{text}</Trans>
        </p>
      </div>
      <SummarySwirl className='relative w-full col-start-1 col-span-12' />
    </section>
  )
}
